<div class="container">
    <div class="text-center m-5">
        <h1>CrossOver Analisi H1</h1>
    </div>

    <!-- <div class="row">
        <div class="col-1 m-1" *ngFor="let m of markets">
            <button class="btn btn-primary" (click)="selectMarket(m.market)">{{m.market}}</button>
        </div>
    </div> -->
    <app-lista-pulsanti-mercati [soloForex]="true" (mercatoSelezionato)="selectMarket($event)"></app-lista-pulsanti-mercati>

    <div class="row mt-5">
        <div class="col-6">
            <app-trading-system-summary [ts]="ts"></app-trading-system-summary>
        </div>
        <div class="col-6">
            <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions"
                [(update)]="updateFlag" [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngularFlag"
                style="width: 100%; height: 400px; display: block;"></highcharts-chart>
                <div>Max DD: {{MaxDD | number: '1.4-4'}}</div>
        </div>
    </div>
</div>
